import script from "./VitaButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaButton.vue?vue&type=script&setup=true&lang=ts"

import "./VitaButton.vue?vue&type=style&index=0&id=7ed8b1d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed8b1d8"]])

export default __exports__